<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card>
            <v-container>
                <v-form ref="form_edit" @submit.prevent="editBlog()">
                    <v-row>
                        <v-col cols="12">
                            <div class="image_content_edit_blog_list">
                                <img v-if="imagePreviewURL" :src="imagePreviewURL" />
                            </div>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input prepend-icon="mdi-file-upload-outline" accept="image/*" v-model="cover_image" label="เพิ่มรูปหน้าปกบทความ (ขนาดแนะนำ 570 x 320 px)" @change="onFileChange"></v-file-input>
                        </v-col>
                        <v-col cols="6">
                        </v-col>
                        <v-col cols="12">
                            <v-text-field label="หัวข้อบทความ" :rules="[v => !!v || 'กรุณากรอกหัวข้อบทความ']" v-model="title" hide-details="auto" required outlined></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field label="เนื้อหาโดยย่อ" :rules="[v => !!v || 'กรุณากรอกเนื้อหาโดยย่อ']" v-model="short_body" hide-details="auto" required outlined></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <div class="mb-2">เนื้อหา</div>
                            <quillEditor ref="myQuillEditor" v-model="body" :options="$store.state.editorOption" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4"></v-col>
                        <v-col cols="4">
                            <v-btn color="#28ab28" class="titlefont_content_edit_blog_list white--text" type="submit" height="50" width="100%">
                                บันทึก
                            </v-btn>
                        </v-col>
                        <v-col cols="4"></v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-card>
        <v-dialog v-model="alert_show_edit" persistent max-width="600">
            <v-card>
                <v-card-title>
                    สำเร็จ
                </v-card-title>

                <v-card-text>
                    แก้ไขบทความเรียบร้อย
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" text @click="confirmSuccess()">
                        ตกลง
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script src="@/previewimage.js"></script><script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import Quill from 'quill'
import {
    ImageDrop
} from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)

import {
    quillEditor
} from 'vue-quill-editor'
import before_image from "@/assets/picture.png";
import contentblog from '@/api/content/contentblog/contentblog.js'
export default {
    components: {
        quillEditor
    },
    data() {
        return {
            loading_page: true,
            imagePreviewURL: before_image,
            alert_show_edit: false,
            cover_image: null,
            title: null,
            short_body: null,
            body: '',
        }
    },
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    methods: {
        async onFileChange(payload) {
            const file = payload
            if (file) {
                this.imagePreviewURL = URL.createObjectURL(file)
                URL.revokeObjectURL(file)
            } else {
                this.imagePreviewURL = before_image
            }
        },
        async blogDetail() {
            this.loading_page = true
            contentblog.blogDetail(this.$store.state.detailBlogId).then((response) => {
                if (response.data.successful === true) {
                    this.imagePreviewURL = response.data.post.image
                    this.title = response.data.post.title
                    this.body = response.data.post.body
                    this.short_body = response.data.post.short_body
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async editBlog() {
            if (this.$refs.form_edit.validate()) {
                this.loading_page = true
                let data = new FormData()
                data.append('cover_image', this.cover_image)
                data.append('title', this.title)
                data.append('short_body', this.short_body)
                data.append('body', this.body)
                contentblog.editBlog(this.$store.state.detailBlogId, data).then((response) => {
                    if (response.data.successful === true) {
                        this.alert_show_edit = true
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
        },
        async confirmSuccess() {
            this.$router.push('/contentblog')
        }
    },
    mounted() {
        this.blogDetail()
    }
}
</script>

<style scoped>
.titlefont_content_edit_blog_list {
    font-size: 22px !important;
}

.image_content_edit_blog_list {
    width: 50%;
}

.image_content_edit_blog_list>img {
    max-width: 100%;
}
</style>
